// ----
// JS for MyAlerts
// ----

var App = App || {};

(function (ns, $) {
    // ----
    // private variables and functions
    // ----
    var alertCheckboxDictionary = {};
    let initialized = false;

    // ----
    // public methods and properties accessible by App.[namespace].[method_name]
    // ----
    ns.Init = function () {
        $('.js-open-update-alerts-modal').off('click');
        $('.js-delete-alert').off('click');
        $('.js-update-alerts').off('click');

        $('.js-alert-select').off('change');
        $('.js-new-alert-select').off('change');


        $('.js-open-update-alerts-modal').on('click', App.MyAlerts.OpenModal);
        $('.js-delete-alert').on('click', App.MyAlerts.DeleteAlert);
        $('.js-update-alerts').on('click', App.MyAlerts.UpdateAlerts);
        $('.js-new-alert-select').on('change', App.MyAlerts.UpdateScheduleIdAttribute);
        $('.js-alert-select').on('change', App.MyAlerts.UpdateAlertSchedule);
        if (SCM.GoogleTagManagerDataLayerEvents) {
            $('input[name="alertCheckBox"]').on('click', App.MyAlerts.SaveAlertCheckboxState);
        }

        if (!initialized) {
            initializeOpenModal();
            initialized = true;
        }
    };

    ns.OpenModal = function () {
        var modal = $('#' + $(this).data('reveal-id'));

        if (modal) {
            $(modal).addClass('open');
            $('.reveal-modal').css('top', '25vh');
            $('body').addClass('on-canvas');
        }
    };

    ns.CloseModal = function () {
        $(this).closest('.reveal-modal').removeClass('open');
        $('body').removeClass('on-canvas');
    };

    ns.BuildAlertItem = function (elem) {
        var alertItem = {};
        alertItem.SiteId = elem.data('siteid');
        alertItem.AlertType = elem.data('alerttypeid');
        alertItem.ResourceId = elem.data('resourceid');
        alertItem.ResourceTypeId = elem.data('resourcetypeid');
        alertItem.IsSubscribed = elem.prop('checked') ? true : false;
        alertItem.ScheduleId = elem.data('scheduleid');
        alertItem.AlertGroupNumber = elem.data('groupnumber');
        alertItem.SearchTerm = elem.data('searchterm');
        alertItem.Eissn = elem.data('eissn') || '';
        return alertItem;
    };

    ns.UpdateScheduleIdAttribute = function () {
        var selectelement = $(this);
        // find nearest check box and update its attribute         
        selectelement.prev('input[type="checkbox"]').attr('data-scheduleid', selectelement.val());
    };

    ns.UpdateAlertSchedule = function () {
        var alertItem = {};
        alertItem.SiteId = $(this).data('siteid');
        alertItem.AlertType = $(this).data('alerttypeid');
        alertItem.ResourceId = $(this).data('resourceid');
        alertItem.ResourceTypeId = $(this).data('resourcetypeid');
        alertItem.IsSubscribed = true;
        alertItem.ScheduleId = $(this).val();

        var myAlertItemArray = [alertItem];
        App.MyAlerts.PostUpdate(myAlertItemArray, $(this));
    };


    ns.DeleteAlert = function () {
        var myAlertItem = App.MyAlerts.BuildAlertItem($(this));
        var myAlertItemArray = [myAlertItem];
        App.MyAlerts.PostUpdate(myAlertItemArray, $(this));
    };

    ns.UpdateAlerts = function () {
        var clickedElement = $(this);
        var modal = clickedElement.closest('#' + $(this).data('modalid'));
        var allCheckboxes = modal.find('input[type="checkbox"]');

        var myAlertItemArray = [];

        allCheckboxes.each(function () {
            var alertItem = App.MyAlerts.BuildAlertItem($(this));
            myAlertItemArray.push(alertItem);
        });

        App.MyAlerts.PostUpdate(myAlertItemArray, clickedElement);
    };

    ns.PostUpdate = function (myAlertItemArray, clickedElement) {
        var alertItemsCopy = myAlertItemArray.slice();

        BatchUpdate(myAlertItemArray)
            .then(function (data) {
                clickedElement.closest('.js-alert-details').find('.close-reveal-modal').click();
                var container = clickedElement.closest('.js-alert-details');
                container.html(data);
                App.MyAlerts.Init();

                if (SCM.GoogleTagManagerDataLayerEvents) {
                    var handledByDictionary = Object.keys(alertCheckboxDictionary).length > 0;

                    $.each(alertCheckboxDictionary, function (key, value) {
                        if (value.checked) {
                            SCM.GoogleTagManagerDataLayerEvents.logJournalAlertSubscribe('my-account', value.eissn || '');
                        } else {
                            SCM.GoogleTagManagerDataLayerEvents.logJournalAlertUnsubscribe(value.eissn || '');
                        }
                    });

                    alertCheckboxDictionary = {};

                    if (!handledByDictionary) {
                        var unsubscribedItem = null;
                        
                        $(alertItemsCopy).each(function () {
                            if (!this.IsSubscribed) {
                                unsubscribedItem = this;
                                return false;
                            }
                        });

                        if (unsubscribedItem) {
                            SCM.GoogleTagManagerDataLayerEvents.logJournalAlertUnsubscribe(unsubscribedItem.Eissn || '');
                        }
                    }
                }
            })
            .catch(function (reason) {
                alert('Unable to update your alerts, please contact customer service');
                console.error(reason);
            });
    };

    ns.SaveAlertCheckboxState = function () {
        var checkboxElement = $(this);
        if (checkboxElement.length) {
            var checkBoxDictionaryKey = createAlertCheckBoxDictionaryKey(checkboxElement);
            alertCheckboxDictionary[checkBoxDictionaryKey] = {
                checked: checkboxElement[0].checked,
                eissn: checkboxElement.data('eissn') || ''
            };
        }
    };

    var BatchSize = 100;

    function createAlertCheckBoxDictionaryKey(checkboxElement) {
        var groupNumber = checkboxElement[0].dataset.groupnumber ? '_gn_' + checkboxElement[0].dataset.groupnumber : '';
        var siteid = checkboxElement[0].dataset.siteid ? '_si_' + checkboxElement[0].dataset.siteid : '';
        var alerttypeid = checkboxElement[0].dataset.alerttypeid ? '_at_' + checkboxElement[0].dataset.alerttypeid : '';
        var resourceid = checkboxElement[0].dataset.resourceid ? '_ri_' + checkboxElement[0].dataset.resourceid : '';
        var resourcetypeid = checkboxElement[0].dataset.resourcetypeid ? '_rti_' + checkboxElement[0].dataset.resourcetypeid : '';
        var scheduleid = checkboxElement[0].dataset.groupnumber ? '_sci_' + checkboxElement[0].dataset.groupnumber : '';
        var checkBoxDictionaryKey = 'checkboxDictionaryKey' + groupNumber + siteid + alerttypeid + resourceid + resourcetypeid + scheduleid;
        return checkBoxDictionaryKey;
    }
    /**
     * 
     * @param {AlertItem[]} myAlertItemArray
     * @returns {Promise}
     */
    function BatchUpdate(myAlertItemArray) {
        return updateNextBatch(myAlertItemArray.splice(0, BatchSize));

        function updateNextBatch(batch) {
            return Update(batch)
                .then(function (data) {
                    var nextBatch = myAlertItemArray.splice(0, BatchSize);
                    return nextBatch.length
                        ? updateNextBatch(nextBatch)
                        : data;
                });
        }
    }

    /**
     *
     * @param {AlertItem[]} myAlertItemArray
     * @returns {Promise}
     */
    function Update(alertBatch) {
        return $.ajax({
            type: 'POST',
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/Content/MyAlerts',
            cache: false,
            data: JSON.stringify(alertBatch),
            contentType: 'application/json'
        })
            .promise()
            .then(function (data) {
                return data ? data : Promise.reject('Invalid response');
            });
    }

    function initializeOpenModal() {
        const $userAlertSignUpModal = $('.js-userAlertSignUpModal');
        if ($userAlertSignUpModal.length) {
            App.MyAlerts.OpenModal.call($userAlertSignUpModal);
        }
    }

    jQuery(function () {
        App.MyAlerts.Init();
    });

})(App.MyAlerts = App.MyAlerts || {}, jQuery);
